import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store";
import LegalDocumentContainer from "../LegalDocumentPages/LegalDocumentContainer";
import * as services from "../../store/service";
import parse from "html-react-parser";
import { Notification } from "../common/Notification";
import * as LoginActions from "../../store/loginService/actions";

const RemoveFamilyMemberDialog: React.FunctionComponent<{ closeDialog(isSuccess?: boolean): void; subCustomerId: string; setThankYouPopupDetails: any }> = (
    props
) => {
    const { register, errors, handleSubmit } = useForm({
        mode: "onSubmit",
    });
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const packageInformationData = useSelector((state: ApplicationState) =>
        state?.protectionPlanState?.protectionPlanData?.packageList ? state?.protectionPlanState?.protectionPlanData?.packageList : []
    );
    const activePackage = packageInformationData ? packageInformationData.find((x) => x.IsActive === true) : null;
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const getFamilyMembers = () => dispatch(LoginActions.actionCreators.getFamilyMembers(true));
    const familyMembers = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.familyMembers ? state.loggedInUser.familyMembers : []
    );
    const accountToRemove = familyMembers.find((x) => x.subcustomerId === props.subCustomerId);
    const isHouseholdMember = accountToRemove && accountToRemove.accountType === "Family Plan Adult" ? true : false;

    const [paymentInfoState, setPaymentInfoState] = useState({
        name: "",
        cardOrAccNumber: "",
        exp: "",
        paymentMethod: "",
        address: {
            addressline1: "",
            addressline2: "",
            city: "",
            state: "",
            zipCode: "",
            country: "",
        },
    });

    const [amountDetailState, setAmountDetailState] = useState({
        familyProtectionCharge: 0,
        countOfUserPaidFamilyMembers: 0,
        totalCost: 0,
        removeFamilyProtectionCost: 0,
        familyProtectionCostPerMember: 0,
        newChargeWithFamilyProtection: 0,
        packagePrice: 0,
        billingText: "",
        subscriptionType: "monthly",
        newCharge: 0,
        todaysNetCharge: 0,
        tax: 0.0,
        billingCycleDescription1: "",
        billingCycleDescription2: "",
        billingCycleDescription3: "",
        currentMonthlyCharge: 0,
        difference: 0,
        newMonthlyChargeStartFrom: "",
        creditedAmount: 0,
        refundAmount: 0,
        packageId: 0,
    });

    const { getTermsOfUseURL, getPrivacyNoticeURL } = LegalDocumentContainer();

    const hasSontiqBrand = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasSontiqBrand
            ? state.configurationState.configuration.partnerConfig.hasSontiqBrand == "true"
                ? true
                : false
            : false
    );
    const closeDialog = (isSuccess?: boolean) => {
        getFamilyMembers();
        document.body.classList.remove("no_scroll");
        props.closeDialog(isSuccess);
    };
    const onSubmit = () => {
        setLoading(true);
        const requestBody = {
            subAccountPKList: [props.subCustomerId],
            payAsYouGoBillingChargeInfoDetails: {
                packageId: activePackage?.PackagId,
                familyProtectionCharge: amountDetailState.familyProtectionCharge,
                countOfUserPaidFamilyMembers: amountDetailState.countOfUserPaidFamilyMembers,
                totalCost: amountDetailState.totalCost,
                removeFamilyProtectionCost: amountDetailState.removeFamilyProtectionCost,
                familyProtectionCostPerMember: amountDetailState.familyProtectionCostPerMember,
                newChargeWithFamilyProtection: amountDetailState.newChargeWithFamilyProtection,
                packagePrice: amountDetailState.packagePrice,
                billingText: amountDetailState.billingText,
                subscriptionType: amountDetailState.subscriptionType,
                newCharge: amountDetailState.newCharge,
                todaysNetCharge: amountDetailState.todaysNetCharge,
                tax: amountDetailState.tax,
                billingCycleDescription1: amountDetailState.billingCycleDescription1,
                billingCycleDescription2: amountDetailState.billingCycleDescription2,
                billingCycleDescription3: amountDetailState.billingCycleDescription3,
                currentMonthlyCharge: amountDetailState.currentMonthlyCharge,
                difference: amountDetailState.difference,
                newMonthlyChargeStartFrom: amountDetailState.newMonthlyChargeStartFrom,
                creditedAmount: amountDetailState.creditedAmount,
                refundAmount: amountDetailState.refundAmount,
            },
        };
        services
            .removeUserPaidFamilyMember(requestBody)
            .then((data) => {
                if (!data["hasError"]) {
                    props.setThankYouPopupDetails({
                        planCost: amountDetailState.packagePrice,
                        totalCost: amountDetailState.totalCost,
                        tax: amountDetailState.tax,
                        familyProtectionCharge: amountDetailState.familyProtectionCharge,
                        newCharge: amountDetailState.newCharge,
                        message: data.billingText,
                        adultCount: amountDetailState.countOfUserPaidFamilyMembers,
                        refund: amountDetailState.refundAmount,
                    });
                    setLoading(false);
                    closeDialog(true);
                } else {
                    Notification({
                        type: "error",
                        title: `Remove ${isHouseholdMember ? "Household" : "Child"} Member Error`,
                        message: `Could not remove ${isHouseholdMember ? "Household" : "Child"} member. Please Try again later.`,
                    });
                    closeDialog(false);
                }
            })
            .catch(() => {
                Notification({
                    type: "error",
                    title: `Remove ${isHouseholdMember ? "Household" : "Child"} Member Error`,
                    message: `Could not remove ${isHouseholdMember ? "Household" : "Child"} member. Please Try again later.`,
                });
                setLoading(false);
            });
    };
    const getSubscriptionType = () => {
        let subscriptionType = "Monthly";
        if (activePackage && activePackage.SubcriptionType) {
            subscriptionType = activePackage.SubcriptionType;
        }
        return subscriptionType?.toUpperCase();
    };

    const getPaymentDetailsData = () => {
        setLoading(true);
        services
            .GetPaymentDetail()
            .then((data) => {
                if (data.billingAddress != null) {
                    const billing = data.billingAddress;
                    if (data.creditCard != null && data.creditCard.cardNumber != null) {
                        setPaymentInfoState({
                            ...paymentInfoState,
                            cardOrAccNumber: data.creditCard.cardNumber,
                            name: data.creditCard.nameOnCard,
                            exp: data.creditCard.expDateMo + "/" + data.creditCard.expDateYr,
                            paymentMethod: data.paymentMethod?.selection,
                            address: {
                                addressline1: billing.address1,
                                addressline2: billing.address2,
                                city: billing.city,
                                state: billing.state.selection,
                                zipCode: billing.zipCode,
                                country: billing.country,
                            },
                        });
                        getPayAsYouGoAmountDetails();
                    } else if (data.eft != null && data.eft.accountNumber != null) {
                        setPaymentInfoState({
                            ...paymentInfoState,
                            cardOrAccNumber: data.eft.accountNumber,
                            name: data.eft.nameOnAccount,
                            paymentMethod: data.paymentMethod?.selection,
                            address: {
                                addressline1: billing.address1,
                                addressline2: billing.address2,
                                city: billing.city,
                                state: billing.state?.selection,
                                zipCode: billing.zipCode,
                                country: billing.country,
                            },
                        });
                        getPayAsYouGoAmountDetails();
                    }
                }
            })
            .catch(() => {
                Notification({
                    type: "error",
                    title: `Get Card Information Error`,
                    message: `Something went wrong, Please try again.`,
                });
                setLoading(false);
            });
    };

    const getPayAsYouGoAmountDetails = () => {
        const requestBody = {
            isUserPaidAdultFamilyMembers: true,
            numberOfNewFamilyMemberAdded: 0,
            isRemoveFamilyRequest: true,
            subAccountPk_For_Remove: props.subCustomerId,
            billingChargeInformation: {
                packageId: activePackage?.PackagId,
                ezshieldId: "",
                packageCode: activePackage?.PackageCode,
                packagePrice: activePackage?.SubcriptionType.toLowerCase() === "yearly" ? activePackage?.PackagePriceYearly : activePackage?.PackagePrice,
                changeType: "PURCHASE",
                subscriptionType: activePackage?.SubcriptionType,
                street1: paymentInfoState?.address?.addressline1 ? paymentInfoState.address.addressline1 : accountInfo?.address1,
                street2: paymentInfoState?.address?.addressline2 ? paymentInfoState.address.addressline2 : accountInfo?.address2,
                city: paymentInfoState?.address?.city ? paymentInfoState.address.city : accountInfo?.city,
                country: paymentInfoState?.address?.country ? paymentInfoState.address.country : accountInfo?.country ? accountInfo.country : "US",
                isAvalaraTaxCalculation: true,
                enrollmentType: "PROVISIONAL",
                region: paymentInfoState?.address?.state ? paymentInfoState.address.state : accountInfo?.state,
                postalCode: paymentInfoState.address.zipCode ? paymentInfoState.address.zipCode : accountInfo?.zipCode,
            },
        };
        setLoading(true);
        services
            .getPayAsYouGoAmountDetails(requestBody)
            .then((data) => {
                if (data.isSuccess) {
                    setAmountDetailState(data);
                } else {
                    Notification({
                        type: "error",
                        title: `Get Payment Details Error`,
                        message: `Something went wrong, Please try again.`,
                    });
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };
    useEffect(() => {
        getPaymentDetailsData();
    }, []);
    return (
        <>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <em className="las la-user-plus"></em>
                </div>
                <h1>Remove {isHouseholdMember ? "Household " : "Child "}Member</h1>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} id="protection-plan-upgrade-form-container">
                <div className={loading ? "loading dialog-body" : "dialog-body"}>
                    <div className="form-row">
                        <h3 className="content-sub-title">Your Cart Summary</h3>
                    </div>
                    <div className="line-divider margin-vertical-xs"></div>

                    <div className="form-row data-grid has-lines row-height-sm">
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label font-weight-bold" id="label-selected-plan">
                                        <strong>Remove Family Protection</strong>
                                    </div>
                                </div>

                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-selected-plan">
                                        ${Number(amountDetailState.removeFamilyProtectionCost).toFixed(2)}
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    {
                        <div className="form-row data-grid has-lines row-height-sm">
                            <fieldset className="form-row inline">
                                <div className="row data-row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-current-charge">
                                            <strong>Plan Cost</strong>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="label-current-charge">
                                            ${Number(amountDetailState.packagePrice).toFixed(2)}
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset className="form-row inline">
                                <div className="row data-row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-current-charge">
                                            <strong>
                                                Family Protection X{" "}
                                                {amountDetailState.countOfUserPaidFamilyMembers ? amountDetailState.countOfUserPaidFamilyMembers : "0"}
                                            </strong>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="label-current-charge">
                                            ${Number(amountDetailState.familyProtectionCharge).toFixed(2)}
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset className="form-row inline">
                                <div className="row data-row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-current-charge">
                                            <strong>Sales Tax</strong>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="label-current-charge">
                                            ${Number(amountDetailState.tax).toFixed(2)}
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset className="form-row inline">
                                <div className="row data-row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-current-charge">
                                            <strong>Total Cost</strong>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="label-current-charge">
                                            ${Number(amountDetailState.totalCost).toFixed(2)}
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    }

                    <div className="form-row data-grid row-height-sm">
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-todays-charge">
                                        <h4 className="status-good">Today's Refund</h4>
                                    </div>
                                </div>

                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-todays-charge">
                                        <div className="row between-xs">
                                            <div className="col-xs col-no-gutter flex-grow-null">
                                                <h4 className="status-good">{"$" + Number(amountDetailState.refundAmount).toFixed(2)}</h4>
                                            </div>
                                            {
                                                <div className="col-xs col-no-gutter flex-grow-null">
                                                    <button
                                                        aria-expanded="false"
                                                        type="button"
                                                        className="btn-default btn-toggle btn-no-padding"
                                                        id="btn_calculation_rule"
                                                        onClick={() => toggle("calculation_rule", "btn_calculation_rule")}
                                                    >
                                                        <span className="btn-toggle-status sr-only">Show</span>
                                                        <span className="btn-text">How is this calculated?</span>
                                                    </button>
                                                </div>
                                            }
                                        </div>

                                        <div id="calculation_rule" style={{ display: "none" }}>
                                            <br />
                                            <p>{parse(amountDetailState.billingCycleDescription1)}</p>
                                            <p>{parse(amountDetailState.billingCycleDescription2)}</p>
                                            <p>{parse(amountDetailState.billingCycleDescription3)}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    {
                        <div className="msg-generic">
                            <div className="form-row data-grid">
                                <div className="form-input">
                                    <label className="form-checkbox-label" htmlFor="isAgreed">
                                        <input type="checkbox" id="isAgreed" name="isAgreed" ref={register({ required: true })} />
                                        {"Cancel Plan" === "Cancel Plan" ? (
                                            <span className="form-checkbox-label-text">
                                                By checking this box, I agree to be bound by the
                                                <span className="default_link">
                                                    &nbsp;
                                                    {hasSontiqBrand ? (
                                                        <a href="https://www.sontiq.com/terms-of-use/" target="_blank">
                                                            Terms of Use
                                                        </a>
                                                    ) : (
                                                        <a
                                                            href={getTermsOfUseURL()}
                                                            target="_blank"
                                                            onClick={() => {
                                                                window.addToDataLayer({ event: "Protection Plan - Show TNC" });
                                                            }}
                                                        >
                                                            Terms of Use
                                                        </a>
                                                    )}{" "}
                                                    and{" "}
                                                    <a
                                                        href={getPrivacyNoticeURL()}
                                                        target="_blank"
                                                        onClick={() => {
                                                            window.open(getPrivacyNoticeURL(), "_blank");
                                                        }}
                                                    >
                                                        Privacy Notice
                                                    </a>
                                                    &nbsp;and I understand that I will be billed $
                                                    {amountDetailState.totalCost ? amountDetailState.totalCost : "0.00"} each{" "}
                                                    {getSubscriptionType()?.toLowerCase() == "monthly"
                                                        ? "month"
                                                        : getSubscriptionType()?.toLowerCase() == "yearly"
                                                        ? "year"
                                                        : getSubscriptionType()?.toLowerCase()}{" "}
                                                    until this membership is canceled.
                                                </span>
                                            </span>
                                        ) : (
                                            <span className="form-checkbox-label-text" style={{ lineHeight: "1.5rem" }}></span>
                                        )}
                                        {errors["billingAddress"] && <span className="form-error">{errors.billingAddress.message}</span>}
                                        {errors["isAgreed"] && errors["isAgreed"].type === "required" && (
                                            <span className="form-error">You must agree to the terms and conditions.</span>
                                        )}
                                    </label>
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null"></div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button type="submit" className="btn-default btn-primary" id="btn-submit-purchase" disabled={false}>
                                <span className="btn-text">continue</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};
export default RemoveFamilyMemberDialog;
